import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="visibility"
export default class extends Controller {
  static targets = ["hideable"];
  declare readonly hideableTargets: HTMLElement[];

  show() {
    this.hideableTargets.forEach((el) => {
      el.hidden = false;
    });
  }

  hide() {
    this.hideableTargets.forEach((el) => {
      el.hidden = true;
    });
  }

  toggle() {
    this.hideableTargets.forEach((el) => {
      el.hidden = !el.hidden;
    });
  }
}
